import React from 'react';
import { AgendaSlot } from './AgendaSlot';
import styles from './AgendaSlotList.module.scss';
import { Slot } from './types';

export const AgendaSlotList = ({
    slots,
    maxSlots,
    keyFactory = (slot: Slot) => slot.title,
}: {
    slots: Slot[];
    maxSlots: number;
    keyFactory?: (slot: Slot) => string;
}) => {
    const slotsToShow = slots.slice(0, maxSlots);

    return (
        <div className={styles.agendaSlotList__container}>
            {slotsToShow.map((slot) => (
                <AgendaSlot key={keyFactory(slot)} slot={slot} />
            ))}
        </div>
    );
};
